export const GET_ALL_PERMISSION_HEAD = 'GET_ALL_PERMISSION_HEAD';
